/**
 * Адреса раздела получателей SIEM и MONQ. Маршруты объявлены в router/AppRoutes.tsx
 * относительными сегментами внутри /integrations (targets, targets/new, targets/:id).
 */

export const INTEGRATIONS_PATH = '/integrations';
export const TARGETS_PATH = `${INTEGRATIONS_PATH}/targets`;
export const NEW_TARGET_PATH = `${TARGETS_PATH}/new`;
/** Вкладка раздела интеграций и параметр адреса со списком получателей (receivers макета, С:247) */
export const INTEGRATIONS_TAB_PARAM = 'tab';
export const RECEIVERS_TAB = 'receivers';
export const RECEIVERS_PATH = `${INTEGRATIONS_PATH}?${INTEGRATIONS_TAB_PARAM}=${RECEIVERS_TAB}`;
/** Параметр нового получателя: профиль, выбранный в каталоге */
export const PROFILE_PARAM = 'profile';

/** Новый получатель с выбранным профилем каталога. */
export function newTargetPath(profile: string): string {
	return `${NEW_TARGET_PATH}?${new URLSearchParams({ [PROFILE_PARAM]: profile })}`;
}

/** Карточка получателя. */
export function targetPath(id: number): string {
	return `${TARGETS_PATH}/${id}`;
}

/** Вкладки карточки получателя (параметр адреса tab, контракты E2.7). */
export type TargetTab = 'overview' | 'deliveries' | 'audit' | 'signals' | 'gaps' | 'settings';

/** Вкладка карточки получателя. */
export function targetTabPath(id: number, tab: TargetTab): string {
	return `${targetPath(id)}?${new URLSearchParams({ [INTEGRATIONS_TAB_PARAM]: tab })}`;
}
